/*
 * Prize trade marketplace.
 *
 * Browsing hits the public Laravel API. Anything that can move a prize goes
 * through the Shopify App Proxy so Shopify signs the request and tells the
 * backend who is actually logged in — the browser never states its own id.
 */
(function () {
  var CONFIG = window.PRIZE_TRADE_CONFIG || {};
  var API = String(CONFIG.apiBase || 'https://home-5017198992.app-ionos.space').replace(/\/+$/, '');
  var PROXY = String(CONFIG.proxyBase || '/apps/ab/prize-trade').replace(/\/+$/, '');
  var CUSTOMER_ID = CONFIG.customerId ? String(CONFIG.customerId) : null;
  var CUSTOMER_NAME = CONFIG.customerName || '';
  // New customer accounts only honour this login path + return_to
  function loginUrl() {
    if (CONFIG.loginUrl) return CONFIG.loginUrl;
    var ret = window.location.pathname + window.location.search;
    if (!ret || ret === '/') ret = '/pages/prize-trade';
    return '/customer_authentication/login?return_to=' + encodeURIComponent(ret);
  }
  var LOGIN_URL = loginUrl();

  var root = document.getElementById('ptrade-root');
  if (!root) return;

  var state = {
    me: null,
    listings: [],
    browse: [],
    browseTotal: 0,
    browsePage: 1,
    browsePages: 1,
    browseLoading: false,
    activeTab: 'browse',
    postPrize: null,
    offerListing: null,
    offerPrizeIds: [],
    completeListing: null,
    loadingMe: false
  };

  var GRADE_COLOURS = {
    A: '#e74c3c', B: '#e67e22', C: '#f39c12', D: '#27ae60',
    E: '#2980b9', F: '#8e44ad', G: '#16a085', H: '#c0392b',
    I: '#2c3e50', J: '#d35400', K: '#7f8c8d'
  };

  var ICONS = {
    empty: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>',
    login: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>'
  };

  /* ---------- helpers ---------- */

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function gradeColour(label) {
    if (!label) return '#555';
    var letter = String(label).trim().charAt(0).toUpperCase();
    return GRADE_COLOURS[letter] || '#555';
  }

  function gradeLabel(prize) {
    if (!prize) return '?';
    if (prize.is_last) return '★';
    return prize.label ? String(prize.label).charAt(0).toUpperCase() : '?';
  }

  function money(value) {
    if (value == null) return '';
    return Number(value).toFixed(2).replace('.', ',') + ' €';
  }

  function toast(message, ok) {
    var el = document.getElementById('ptrade-toast');
    el.textContent = message;
    el.className = 'ptrade-toast is-visible ' + (ok ? 'is-ok' : 'is-bad');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () { el.className = 'ptrade-toast'; }, 4000);
  }

  function stateBlock(icon, heading, text, actionHtml) {
    return '<div class="ptrade-state" style="grid-column:1/-1">'
      + '<div class="ptrade-state-icon">' + icon + '</div>'
      + '<h2>' + esc(heading) + '</h2>'
      + '<p>' + esc(text) + '</p>'
      + (actionHtml || '')
      + '</div>';
  }

  function loginBlock(text) {
    return stateBlock(
      ICONS.login,
      'Bitte anmelden',
      text || 'Melde dich an, um Preise anzubieten, Anzeigen zu verwalten und Angebote zu senden.',
      '<div class="ptrade-state-actions">'
        + '<a class="ptrade-btn ptrade-btn--solid" href="' + esc(LOGIN_URL) + '">Anmelden</a>'
        + '<a class="ptrade-btn" href="/account/register">Konto erstellen</a>'
        + '</div>'
        + '<p class="ptrade-hint" style="margin-top:14px;max-width:460px;margin-left:auto;margin-right:auto">'
        + 'Schon eingeloggt und es klappt trotzdem nicht? Zuerst <a href="/account/logout">abmelden</a>, '
        + 'dann hier wieder anmelden — nur kurz das Konto öffnen reicht oft nicht.'
        + '</p>'
    );
  }

  function markLoggedIn(customerId, customerName) {
    if (!customerId) return;
    CUSTOMER_ID = String(customerId);
    if (customerName) CUSTOMER_NAME = customerName;

    var heroActions = root.querySelector('.ptrade-hero .ptrade-state-actions');
    if (heroActions && !heroActions.querySelector('[data-ptrade-goto="mine"]')) {
      heroActions.innerHTML =
        '<button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="mine">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
        + ' Preis anbieten</button>'
        + '<a class="ptrade-btn" href="/pages/kuji-collection">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg>'
        + ' Meine Sammlung</a>';
      bindGotoButtons(heroActions);
    }
  }

  /** Anything that changes ownership must be signed by Shopify. */
  function proxyRequest(path, options) {
    options = options || {};

    return fetch(PROXY + path, {
      method: options.method || 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: options.body ? JSON.stringify(options.body) : undefined
    }).then(function (response) {
      return response.json().catch(function () {
        return { status: false, message: 'Unerwartete Antwort vom Server.' };
      }).then(function (data) {
        if (!response.ok) {
          var error = new Error(data.message || 'Das hat leider nicht geklappt.');
          error.code = data.code;
          error.httpStatus = response.status;
          throw error;
        }
        return data;
      });
    });
  }

  /* ---------- tabs ---------- */

  var VALID_TABS = ['browse', 'mine', 'listings', 'inbox', 'offers'];

  function tabFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = params.get('tab');
      if (VALID_TABS.indexOf(fromQuery) !== -1) {
        return fromQuery;
      }
    } catch (e) { /* ignore */ }

    var hashTab = (window.location.hash || '').replace('#', '');
    if (VALID_TABS.indexOf(hashTab) !== -1) {
      return hashTab;
    }

    return null;
  }

  function syncTabToUrl(name) {
    try {
      var url = new URL(window.location.href);
      if (name === 'browse') {
        url.searchParams.delete('tab');
      } else {
        url.searchParams.set('tab', name);
      }
      // Drop legacy hash so refresh only uses ?tab=
      url.hash = '';
      window.history.replaceState(null, '', url.pathname + url.search);
    } catch (e) { /* ignore */ }
  }

  function setTab(name) {
    if (VALID_TABS.indexOf(name) === -1) {
      name = 'browse';
    }

    state.activeTab = name;

    root.querySelectorAll('[data-ptrade-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.dataset.ptradeTab === name);
    });
    root.querySelectorAll('[data-ptrade-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.dataset.ptradePanel === name);
    });

    syncTabToUrl(name);

    if (name !== 'browse' && !state.me && !state.loadingMe) {
      loadMe();
    }

    if (name === 'browse') {
      maybeLoadMoreBrowse();
    }
  }

  root.querySelectorAll('[data-ptrade-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () { setTab(tab.dataset.ptradeTab); });
  });
  root.querySelectorAll('[data-ptrade-goto]').forEach(function (btn) {
    btn.addEventListener('click', function () { setTab(btn.dataset.ptradeGoto); });
  });

  function updateTabCounts() {
    var listingCount = state.me ? state.me.listings.filter(function (l) {
      return l.status === 'open' || l.status === 'reserved';
    }).length : 0;

    var incomingPending = state.me ? state.me.listings.reduce(function (total, listing) {
      return total + (listing.offers || []).filter(function (o) { return o.status === 'pending'; }).length;
    }, 0) : 0;

    var sentCount = state.me ? (state.me.sent_offers || []).filter(function (o) {
      return o.status !== 'withdrawn';
    }).length : 0;

    setCount('listings', listingCount);
    setCount('inbox', incomingPending);
    setCount('offers', sentCount);
  }

  function setCount(key, value) {
    var badge = root.querySelector('[data-ptrade-count="' + key + '"]');
    if (!badge) return;
    badge.textContent = value;
    badge.hidden = value < 1;
  }

  /* ---------- browse ---------- */

  var browseGrid = document.getElementById('ptrade-browse-grid');
  var browseMeta = document.getElementById('ptrade-browse-meta');
  var browseLabel = document.getElementById('ptrade-browse-label');
  var browseEnd = document.getElementById('ptrade-browse-end');
  var browseEndStatus = document.getElementById('ptrade-browse-end-status');
  var browseSentinel = document.getElementById('ptrade-browse-sentinel');
  var searchInput = document.getElementById('ptrade-search');
  var typeSelect = document.getElementById('ptrade-type');
  var lotterySelect = document.getElementById('ptrade-lottery');
  var sortSelect = document.getElementById('ptrade-sort');
  var BROWSE_PER_PAGE = 24;

  var searchTimer = null;
  searchInput.addEventListener('input', function () {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { loadBrowse(true); }, 350);
  });
  [typeSelect, lotterySelect, sortSelect].forEach(function (el) {
    el.addEventListener('change', function () { loadBrowse(true); });
  });

  function browseHasMore() {
    return (state.browsePage || 1) < (state.browsePages || 1);
  }

  function setBrowseEndStatus(text) {
    if (!browseEndStatus) return;
    browseEndStatus.textContent = text || '';
  }

  function loadBrowse(reset) {
    if (reset !== false) reset = true;
    if (state.browseLoading) return;
    if (!reset && !browseHasMore()) return;

    var nextPage = reset ? 1 : (state.browsePage || 1) + 1;
    var params = new URLSearchParams();
    params.set('page', String(nextPage));
    params.set('per_page', String(BROWSE_PER_PAGE));
    if (searchInput.value.trim()) params.set('q', searchInput.value.trim());
    if (typeSelect.value) params.set('type', typeSelect.value);
    if (lotterySelect.value) params.set('product_id', lotterySelect.value);
    if (sortSelect.value) params.set('sort', sortSelect.value);

    state.browseLoading = true;
    if (browseEnd) browseEnd.hidden = false;
    setBrowseEndStatus(reset ? '' : 'Weitere Angebote werden geladen…');

    fetch(API + '/api/trade/listings?' + params.toString())
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = data.items || [];
        state.browse = reset ? items : state.browse.concat(items);
        state.browseTotal = data.total != null ? data.total : state.browse.length;
        state.browsePage = data.page || nextPage;
        state.browsePages = data.pages || 1;
        renderBrowse();
      })
      .catch(function () {
        if (reset) {
          browseMeta.hidden = true;
          if (browseEnd) browseEnd.hidden = true;
          browseGrid.innerHTML = stateBlock(
            ICONS.alert,
            'Angebote konnten nicht geladen werden',
            'Bitte lade die Seite neu und versuche es erneut.'
          );
        } else {
          setBrowseEndStatus('Konnte nicht laden — weiter nach unten scrollen, um es erneut zu versuchen.');
          toast('Weitere Angebote konnten nicht geladen werden.', false);
        }
      })
      .then(function () {
        state.browseLoading = false;
        if (browseHasMore() && isBrowseNearBottom()) {
          loadBrowse(false);
        }
      });
  }

  function isBrowseNearBottom() {
    if (state.activeTab !== 'browse' || !browseSentinel) return false;
    var rect = browseSentinel.getBoundingClientRect();
    return rect.top < (window.innerHeight + 280);
  }

  function maybeLoadMoreBrowse() {
    if (state.activeTab !== 'browse') return;
    if (!browseHasMore() || state.browseLoading) return;
    if (isBrowseNearBottom()) loadBrowse(false);
  }

  if (browseSentinel && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        maybeLoadMoreBrowse();
      }
    }, { rootMargin: '280px 0px' }).observe(browseSentinel);
  }

  window.addEventListener('scroll', maybeLoadMoreBrowse, { passive: true });

  function pendingOfferForListing(listingId) {
    if (!state.me || !state.me.sent_offers) return null;
    return state.me.sent_offers.find(function (offer) {
      return offer.listing_id === listingId && offer.status === 'pending';
    }) || null;
  }

  function renderBrowse() {
    if (!state.browse.length) {
      browseMeta.hidden = true;
      if (browseEnd) browseEnd.hidden = true;
      browseGrid.innerHTML = stateBlock(
        ICONS.search,
        'Noch keine Angebote',
        'Sei die erste Person, die hier einen Preis anbietet.',
        CUSTOMER_ID
          ? '<div class="ptrade-state-actions"><button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="mine">Preis anbieten</button></div>'
          : '<div class="ptrade-state-actions"><a class="ptrade-btn ptrade-btn--solid" href="' + esc(LOGIN_URL) + '">Anmelden</a></div>'
      );
      bindGotoButtons(browseGrid);
      return;
    }

    browseMeta.hidden = false;
    var total = state.browseTotal != null ? state.browseTotal : state.browse.length;
    browseLabel.textContent = total + (total === 1 ? ' Angebot' : ' Angebote');
    browseGrid.innerHTML = state.browse.map(browseCard).join('');
    bindWantsToggles(browseGrid);

    browseGrid.querySelectorAll('[data-offer-listing]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openOfferModal(Number(btn.dataset.offerListing));
      });
    });

    browseGrid.querySelectorAll('[data-ptrade-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTab(btn.dataset.ptradeGoto); });
    });

    if (browseEnd) browseEnd.hidden = false;
    if (!state.browseLoading) setBrowseEndStatus('');
  }

  function wantsBlockHtml(text, prefix) {
    if (!text) return '';
    return '<div class="ptrade-wants-block">'
      + '<p class="ptrade-card-wants" data-ptrade-wants>' + (prefix || '') + esc(text) + '</p>'
      + '<button type="button" class="ptrade-wants-toggle" data-ptrade-wants-toggle hidden aria-expanded="false">Mehr lesen</button>'
      + '</div>';
  }

  function bindWantsToggles(root) {
    if (!root) return;

    function wire() {
      root.querySelectorAll('[data-ptrade-wants-toggle]').forEach(function (btn) {
        if (btn.dataset.bound === '1') return;
        btn.dataset.bound = '1';

        var block = btn.closest('.ptrade-wants-block');
        var textEl = block && block.querySelector('[data-ptrade-wants]');
        if (!textEl) return;

        var overflows = textEl.scrollHeight > textEl.clientHeight + 1
          || (textEl.textContent || '').length > 95;
        if (overflows) btn.hidden = false;

        btn.addEventListener('click', function () {
          var open = block.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? 'Weniger' : 'Mehr lesen';
        });
      });
    }

    requestAnimationFrame(wire);
  }

  function browseCard(listing) {
    var prize = listing.prize || {};
    var isMine = CUSTOMER_ID && listing.owner_id === CUSTOMER_ID;
    var pendingOffer = !isMine && pendingOfferForListing(listing.id);
    var typeLabel = listing.type === 'sell' ? 'Verkauf' : (listing.type === 'both' ? 'Tausch / Kauf' : 'Tausch');

    var actionHtml;
    if (isMine) {
      actionHtml = '<span class="ptrade-owner">Deine Anzeige</span>';
    } else if (pendingOffer) {
      actionHtml = '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--sent" data-ptrade-goto="offers">Angebot gesendet</button>';
    } else {
      actionHtml = '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--solid" data-offer-listing="' + listing.id + '">Angebot</button>';
    }

    return '<article class="ptrade-card">'
      + '<div class="ptrade-card-img-wrap">'
      + (prize.image
        ? '<img class="ptrade-card-img" src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
        : '<div class="ptrade-card-img ptrade-card-img--empty">?</div>')
      + '<span class="ptrade-grade" style="background:' + gradeColour(prize.label) + '">' + esc(gradeLabel(prize)) + '</span>'
      + '<span class="ptrade-tag ptrade-tag--' + esc(listing.type) + '">' + esc(typeLabel) + '</span>'
      + '</div>'
      + '<div class="ptrade-card-body">'
      + '<h3 class="ptrade-card-name">' + esc(prize.title || 'Preis') + '</h3>'
      + (prize.lottery_name ? '<div class="ptrade-card-sub">' + esc(prize.lottery_name) + '</div>' : '')
      + (listing.asking_price ? '<div class="ptrade-card-price">' + esc(money(listing.asking_price)) + '</div>' : '')
      + wantsBlockHtml(listing.wants, 'Sucht: ')
      + (prize.ships_themselves ? '<p class="ptrade-card-wants ptrade-card-wants--note">Versand untereinander</p>' : '')
      + '<div class="ptrade-card-foot">'
      + '<span class="ptrade-owner">von ' + esc(listing.owner_name) + '</span>'
      + actionHtml
      + '</div>'
      + '</div>'
      + '</article>';
  }

  function bindGotoButtons(scope) {
    scope.querySelectorAll('[data-ptrade-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTab(btn.dataset.ptradeGoto); });
    });
  }

  /* ---------- my prizes / listings / offers ---------- */

  var mineGrid = document.getElementById('ptrade-mine-grid');
  var blockedGrid = document.getElementById('ptrade-blocked-grid');
  var blockedMeta = document.getElementById('ptrade-blocked-meta');
  var listingsGrid = document.getElementById('ptrade-listings-grid');
  var inboxGrid = document.getElementById('ptrade-inbox-grid');
  var offersGrid = document.getElementById('ptrade-offers-grid');

  function loadMe(options) {
    options = options || {};

    if (!options.silent) {
      state.loadingMe = true;
      mineGrid.innerHTML = skeletons(4);
    }

    return proxyRequest('/me')
      .then(function (data) {
        if (data.customer_id) {
          markLoggedIn(data.customer_id, data.customer_name || CUSTOMER_NAME);
        }
        state.me = data;
        if (!options.silent) {
          renderMine();
          renderListings();
          renderReceivedOffers();
          renderSentOffers();
          updateTabCounts();
        }
        if (state.browse && state.browse.length) {
          renderBrowse();
        }
      })
      .catch(function (error) {
        if (options.silent) return;

        var message = error.code === 'login_required' || error.httpStatus === 401 || error.httpStatus === 403
          ? loginBlock('Melde dich an, um Preise anzubieten, Anzeigen zu verwalten und Angebote zu senden.')
          : stateBlock(ICONS.alert, 'Konnte nicht geladen werden', error.message);

        mineGrid.innerHTML = message;
        listingsGrid.innerHTML = message;
        inboxGrid.innerHTML = message;
        offersGrid.innerHTML = message;
      })
      .finally(function () {
        if (!options.silent) {
          state.loadingMe = false;
        }
      });
  }

  function skeletons(count) {
    var out = '';
    for (var i = 0; i < count; i++) out += '<div class="ptrade-skeleton"></div>';
    return out;
  }

  function renderMine() {
    var prizes = state.me.prizes || [];

    if (!prizes.length) {
      mineGrid.innerHTML = stateBlock(
        ICONS.empty,
        'Keine tauschbaren Preise',
        'Sobald du einen Preis freirubbelst, taucht er hier auf — auch wenn er schon bei dir zu Hause ist.',
        '<div class="ptrade-state-actions"><a class="ptrade-btn ptrade-btn--solid" href="/collections/all">Kuji ansehen</a></div>'
      );
    } else {
      mineGrid.innerHTML = prizes.map(function (prize) {
        return prizeCard(prize, '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--solid" data-post-prize="' + prize.id + '">Anbieten</button>');
      }).join('');

      mineGrid.querySelectorAll('[data-post-prize]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openPostModal(Number(btn.dataset.postPrize));
        });
      });
    }

    var blocked = state.me.blocked_prizes || [];
    blockedMeta.hidden = blocked.length === 0;
    blockedGrid.innerHTML = blocked.map(function (prize) {
      return prizeCard(prize, '', true);
    }).join('');
  }

  function prizeCard(prize, actionHtml, muted) {
    return '<article class="ptrade-card' + (muted ? ' is-muted' : '') + '">'
      + '<div class="ptrade-card-img-wrap">'
      + (prize.image
        ? '<img class="ptrade-card-img" src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
        : '<div class="ptrade-card-img ptrade-card-img--empty">?</div>')
      + '<span class="ptrade-grade" style="background:' + gradeColour(prize.label) + '">' + esc(gradeLabel(prize)) + '</span>'
      + '</div>'
      + '<div class="ptrade-card-body">'
      + '<h3 class="ptrade-card-name">' + esc(prize.title || 'Preis') + '</h3>'
      + (prize.lottery_name ? '<div class="ptrade-card-sub">' + esc(prize.lottery_name) + '</div>' : '')
      + (prize.variant ? '<div class="ptrade-card-sub">Variante ' + esc(prize.variant) + '</div>' : '')
      + (prize.ships_themselves && !prize.blocked_reason
        ? '<div class="ptrade-note ptrade-note--flat">Schon bei dir — Versand klärt ihr untereinander.</div>'
        : '')
      + (prize.blocked_reason ? '<div class="ptrade-note ptrade-note--flat">' + esc(prize.blocked_reason) + '</div>' : '')
      + (actionHtml ? '<div class="ptrade-card-foot">' + actionHtml + '</div>' : '')
      + '</div>'
      + '</article>';
  }

  function renderListings() {
    var listings = state.me.listings || [];

    if (!listings.length) {
      listingsGrid.innerHTML = stateBlock(
        ICONS.empty,
        'Noch keine Anzeige',
        'Wähle unter "Meine Preise" einen Preis aus und biete ihn an.',
        '<div class="ptrade-state-actions"><button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="mine">Meine Preise</button></div>'
      );
      bindGotoButtons(listingsGrid);
      return;
    }

    listingsGrid.innerHTML = listings.map(listingCard).join('');
    bindListingActions();
  }

  function listingCard(listing) {
    var prize = listing.prize || {};
    var pendingCount = (listing.offers || []).filter(function (o) { return o.status === 'pending'; }).length;
    var isActive = listing.status === 'open' || listing.status === 'reserved';

    var statusNote = '';
    if (listing.status === 'locked') {
      statusNote = '<div class="ptrade-note">' + esc(listing.lock_reason || 'Dieser Preis ist im Versand.') + '</div>';
    } else if (listing.status === 'completed') {
      statusNote = '<div class="ptrade-note">'
        + (listing.completed_type === 'sold' ? 'Verkauft' : 'Getauscht')
        + ' — wir legen den Preis ins richtige Paket.</div>';
    }

    var offerHint = '';
    if (pendingCount > 0) {
      offerHint = '<button type="button" class="ptrade-inbox-link" data-ptrade-goto="inbox">'
        + pendingCount + ' offenes Angebot' + (pendingCount > 1 ? 'e' : '') + ' ansehen →</button>';
    } else if (isActive) {
      offerHint = '<p class="ptrade-card-wants">Noch keine Angebote.</p>';
    }

    return '<article class="ptrade-card" data-listing-card="' + listing.id + '">'
      + '<div class="ptrade-card-img-wrap">'
      + (prize.image
        ? '<img class="ptrade-card-img" src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
        : '<div class="ptrade-card-img ptrade-card-img--empty">?</div>')
      + '<span class="ptrade-grade" style="background:' + gradeColour(prize.label) + '">' + esc(gradeLabel(prize)) + '</span>'
      + '</div>'
      + '<div class="ptrade-card-body">'
      + '<h3 class="ptrade-card-name">' + esc(prize.title || 'Preis') + '</h3>'
      + (listing.asking_price ? '<div class="ptrade-card-price">' + esc(money(listing.asking_price)) + '</div>' : '')
      + (listing.wants ? '<div class="ptrade-card-sub">' + esc(listing.wants) + '</div>' : '')
      + statusNote
      + offerHint
      + (isActive
        ? '<div class="ptrade-card-foot ptrade-card-foot--actions">'
          + '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--danger" data-cancel-listing="' + listing.id + '">Löschen</button>'
          + '<button type="button" class="ptrade-btn ptrade-btn--sm" data-complete-listing="' + listing.id + '">Deal eintragen</button>'
          + '</div>'
        : '')
      + '</div>'
      + '</article>';
  }

  function offerRow(offer, listing) {
    var isPending = offer.status === 'pending';
    var what = offer.offer_type === 'cash'
      ? money(offer.cash_amount)
      : offeredPrizesHtml(offer);

    return '<div class="ptrade-offer">'
      + '<div class="ptrade-offer-head">'
      + '<span class="ptrade-offer-who">' + esc(offer.offerer_name) + '</span>'
      + '<span class="ptrade-offer-status is-' + esc(offer.status) + '">' + esc(statusText(offer.status)) + '</span>'
      + '</div>'
      + '<div>' + (offer.offer_type === 'cash' ? esc(what) : what) + '</div>'
      + (offer.message ? '<div style="color:#6b6258">„' + esc(offer.message) + '"</div>' : '')
      + (offer.contact_value
        ? '<div class="ptrade-contact-row">'
          + '<span class="ptrade-contact-label">' + esc(contactMethodLabel(offer.contact_method)) + ':</span> '
          + '<span class="ptrade-contact-value">' + esc(offer.contact_value) + '</span>'
          + (offer.contact_link
            ? ' · <a class="ptrade-contact" href="' + esc(offer.contact_link) + '" target="_blank" rel="noopener">Öffnen</a>'
            : '')
          + '</div>'
        : '')
      + (isPending && (listing.status === 'open' || listing.status === 'reserved')
        ? '<div class="ptrade-offer-actions">'
          + '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--ghost" data-decline-offer="' + offer.id + '">Ablehnen</button>'
          + '<button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--solid" data-accept-offer="' + offer.id + '">Annehmen</button>'
          + '</div>'
        : '')
      + '</div>';
  }

  function statusText(status) {
    switch (status) {
      case 'pending': return 'offen';
      case 'accepted': return 'angenommen';
      case 'declined': return 'abgelehnt';
      case 'withdrawn': return 'zurückgezogen';
      default: return status;
    }
  }

  function contactMethodLabel(method) {
    switch (method) {
      case 'whatsapp': return 'WhatsApp';
      case 'instagram': return 'Instagram';
      case 'discord': return 'Discord';
      case 'email': return 'E-Mail';
      default: return method || 'Kontakt';
    }
  }

  function offeredPrizes(offer) {
    if (offer.offered_prizes && offer.offered_prizes.length) {
      return offer.offered_prizes;
    }
    return offer.offered_prize ? [offer.offered_prize] : [];
  }

  function offeredPrizesHtml(offer) {
    var prizes = offeredPrizes(offer);
    if (!prizes.length) return 'Tausch';

    return '<div class="ptrade-offered-prizes">'
      + prizes.map(function (prize) {
        var label = prize.label ? prize.label + ' — ' : '';
        var title = label + (prize.title || 'Preis');
        return '<div class="ptrade-offered-prize">'
          + (prize.image
            ? '<img class="ptrade-offered-prize-img" src="' + esc(prize.image) + '" alt="' + esc(title) + '" loading="lazy">'
            : '<div class="ptrade-offered-prize-img ptrade-offered-prize-img--empty">?</div>')
          + '<span class="ptrade-offered-prize-text">'
          + '<span class="ptrade-offered-prize-grade" style="background:' + gradeColour(prize.label) + '">'
          + esc(gradeLabel(prize)) + '</span>'
          + esc(title)
          + '</span>'
          + '</div>';
      }).join('')
      + '</div>';
  }

  function bindListingActions() {
    listingsGrid.querySelectorAll('[data-ptrade-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTab(btn.dataset.ptradeGoto); });
    });

    listingsGrid.querySelectorAll('[data-cancel-listing]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        askConfirm('Anzeige wirklich löschen?', {
          title: 'Anzeige löschen',
          confirmLabel: 'Löschen',
          danger: true
        }).then(function (ok) {
          if (!ok) return;
          runAction(btn, '/listings/' + btn.dataset.cancelListing + '/cancel');
        });
      });
    });

    listingsGrid.querySelectorAll('[data-complete-listing]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openCompleteModal(Number(btn.dataset.completeListing));
      });
    });
  }

  function collectReceivedOffers() {
    var rows = [];

    (state.me.listings || []).forEach(function (listing) {
      (listing.offers || []).filter(function (o) { return o.status !== 'withdrawn'; }).forEach(function (offer) {
        rows.push({ listing: listing, offer: offer });
      });
    });

    rows.sort(function (a, b) {
      if (a.offer.status === 'pending' && b.offer.status !== 'pending') return -1;
      if (b.offer.status === 'pending' && a.offer.status !== 'pending') return 1;
      return (b.offer.id || 0) - (a.offer.id || 0);
    });

    return rows;
  }

  function renderReceivedOffers() {
    var rows = collectReceivedOffers();

    if (!rows.length) {
      inboxGrid.innerHTML = stateBlock(
        ICONS.empty,
        'Noch keine Angebote erhalten',
        'Sobald jemand auf deine Anzeige antwortet, siehst du es hier.',
        '<div class="ptrade-state-actions"><button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="listings">Meine Anzeigen</button></div>'
      );
      bindGotoButtons(inboxGrid);
      return;
    }

    inboxGrid.innerHTML = rows.map(function (row) {
      var listing = row.listing;
      var offer = row.offer;
      var prize = listing.prize || {};
      var label = prize.label ? prize.label + ' — ' : '';

      return '<article class="ptrade-inbox-item">'
        + '<div class="ptrade-inbox-thumb">'
        + (prize.image
          ? '<img src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
          : '<div class="ptrade-card-img ptrade-card-img--empty">?</div>')
        + '<span class="ptrade-grade" style="background:' + gradeColour(prize.label) + '">' + esc(gradeLabel(prize)) + '</span>'
        + '</div>'
        + '<div class="ptrade-inbox-body">'
        + '<div class="ptrade-inbox-listing">Deine Anzeige<br><strong>' + esc(label + (prize.title || 'Preis')) + '</strong></div>'
        + offerRow(offer, listing)
        + '</div>'
        + '</article>';
    }).join('');

    bindInboxActions();
  }

  function bindInboxActions() {
    inboxGrid.querySelectorAll('[data-accept-offer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var offerId = Number(btn.dataset.acceptOffer);
        var row = collectReceivedOffers().find(function (item) {
          return item.offer.id === offerId;
        });
        askConfirm(acceptOfferConfirmMessage(row && row.offer, row && row.listing), {
          title: 'Angebot annehmen',
          confirmLabel: 'Annehmen'
        }).then(function (ok) {
          if (!ok) return;
          runAction(btn, '/offers/' + offerId + '/accept');
        });
      });
    });

    inboxGrid.querySelectorAll('[data-decline-offer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        askConfirm('Angebot wirklich ablehnen?', {
          title: 'Angebot ablehnen',
          confirmLabel: 'Ablehnen',
          danger: true
        }).then(function (ok) {
          if (!ok) return;
          runAction(btn, '/offers/' + btn.dataset.declineOffer + '/decline');
        });
      });
    });
  }

  function acceptOfferConfirmMessage(offer, listing) {
    var prizes = [];
    if (listing && listing.prize) prizes.push(listing.prize);
    if (offer && offer.offer_type !== 'cash') {
      prizes = prizes.concat(offeredPrizes(offer));
    }

    var customerHeld = 0;
    var warehouse = 0;
    prizes.forEach(function (prize) {
      if (prize && prize.ships_themselves) customerHeld += 1;
      else warehouse += 1;
    });

    if (customerHeld && !warehouse) {
      return 'Angebot annehmen? Die Preise sind schon bei euch — Versand und Übergabe klärt ihr untereinander.';
    }
    if (customerHeld && warehouse) {
      return 'Angebot annehmen? Preise, die noch bei uns lagern, legen wir ins richtige Paket. Schon verschickte Preise klärt ihr untereinander.';
    }
    return 'Angebot annehmen? Wir legen die Preise dann in die richtigen Pakete.';
  }

  function runAction(button, path, body) {
    button.disabled = true;

    proxyRequest(path, { method: 'POST', body: body || {} })
      .then(function (data) {
        toast(data.message || 'Erledigt.', true);
        if (data.standalone) {
          toast('Die andere Person hat kein offenes Paket — wir melden uns wegen der Adresse.', true);
        }
        return loadMe();
      })
      .then(function () { loadBrowse(); })
      .catch(function (error) {
        toast(error.message, false);
        button.disabled = false;
      });
  }

  function renderSentOffers() {
    var offers = state.me.sent_offers || [];
    var incomingPending = state.me.listings.reduce(function (total, listing) {
      return total + (listing.offers || []).filter(function (o) { return o.status === 'pending'; }).length;
    }, 0);

    if (!offers.length) {
      var hint = incomingPending
        ? 'Du hast ' + incomingPending + ' neues Angebot auf deine Anzeigen — schau unter „Eingehend“.'
        : 'Schau dir die offenen Angebote an und melde dich bei jemandem.';

      offersGrid.innerHTML = stateBlock(
        ICONS.empty,
        'Noch keine Angebote gesendet',
        hint,
        '<div class="ptrade-state-actions">'
          + (incomingPending
            ? '<button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="inbox">Eingehend</button>'
            : '<button type="button" class="ptrade-btn ptrade-btn--solid" data-ptrade-goto="browse">Angebote ansehen</button>')
          + '</div>'
      );
      bindGotoButtons(offersGrid);
      return;
    }

    offersGrid.innerHTML = offers.map(function (offer) {
      var listing = offer.listing || {};
      var prize = listing.prize || {};
      var gave = offer.offer_type === 'cash' ? esc(money(offer.cash_amount)) : offeredPrizesHtml(offer);

      return '<article class="ptrade-card">'
        + '<div class="ptrade-card-img-wrap">'
        + (prize.image
          ? '<img class="ptrade-card-img" src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
          : '<div class="ptrade-card-img ptrade-card-img--empty">?</div>')
        + '<span class="ptrade-grade" style="background:' + gradeColour(prize.label) + '">' + esc(gradeLabel(prize)) + '</span>'
        + '</div>'
        + '<div class="ptrade-card-body">'
        + '<h3 class="ptrade-card-name">' + esc(prize.title || 'Preis') + '</h3>'
        + '<div class="ptrade-card-sub">Dein Angebot: ' + gave + '</div>'
        + '<div class="ptrade-note' + (offer.status === 'accepted' ? '' : ' ptrade-note--flat') + '">'
        + esc(statusText(offer.status)) + '</div>'
        + (offer.status === 'accepted' && listing && (listing.contact_value || listing.contact_link)
          ? '<div class="ptrade-contact-row">'
            + (listing.contact_value
              ? '<span class="ptrade-contact-label">' + esc(contactMethodLabel(listing.contact_method)) + ':</span> '
                + '<span class="ptrade-contact-value">' + esc(listing.contact_value) + '</span>'
              : '')
            + (listing.contact_link
              ? (listing.contact_value ? ' · ' : '')
                + '<a class="ptrade-contact" href="' + esc(listing.contact_link) + '" target="_blank" rel="noopener">Jetzt schreiben</a>'
              : '')
            + '</div>'
          : '')
        + (offer.status === 'pending'
          ? '<div class="ptrade-card-foot"><button type="button" class="ptrade-btn ptrade-btn--sm ptrade-btn--danger" data-withdraw-offer="' + offer.id + '">Zurückziehen</button></div>'
          : '')
        + '</div>'
        + '</article>';
    }).join('');

    offersGrid.querySelectorAll('[data-withdraw-offer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        runAction(btn, '/offers/' + btn.dataset.withdrawOffer + '/withdraw');
      });
    });
  }

  /* ---------- modals ---------- */

  function syncModalScrollLock() {
    var hasOpen = !!document.querySelector('.ptrade-modal.is-open');
    document.documentElement.classList.toggle('ptrade-modal-open', hasOpen);
    document.body.classList.toggle('ptrade-modal-open', hasOpen);
  }

  function openModal(id) {
    document.getElementById(id).classList.add('is-open');
    syncModalScrollLock();
  }

  function closeModal(id) {
    document.getElementById(id).classList.remove('is-open');
    syncModalScrollLock();
  }

  function closeModalEl(modal) {
    modal.classList.remove('is-open');
    syncModalScrollLock();
    if (modal.id === 'ptrade-offer-modal') {
      offerLoadToken += 1;
      setOfferModalMode('form');
      var submitBtn = document.getElementById('ptrade-offer-submit');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Angebot senden';
      }
      var choices = document.getElementById('ptrade-offer-choices');
      if (choices) {
        choices.classList.remove('is-loading');
        choices.style.minHeight = '';
        choices.style.background = '';
        choices.style.border = '';
        choices.style.borderRadius = '';
      }
      var prizeCount = document.getElementById('ptrade-offer-prize-count');
      if (prizeCount) prizeCount.hidden = false;
    }
    if (modal.id === 'ptrade-confirm-modal') {
      finishConfirm(false);
    }
  }

  var confirmResolver = null;

  function finishConfirm(ok) {
    if (!confirmResolver) return;
    var resolve = confirmResolver;
    confirmResolver = null;
    resolve(!!ok);
  }

  /**
   * Styled confirm modal — same look as the other prize-trade dialogs.
   * options: { title, confirmLabel, danger }
   */
  function askConfirm(message, options) {
    options = options || {};
    var modal = document.getElementById('ptrade-confirm-modal');
    var titleEl = document.getElementById('ptrade-confirm-title');
    var msgEl = document.getElementById('ptrade-confirm-message');
    var okBtn = document.getElementById('ptrade-confirm-ok');
    if (!modal || !msgEl || !okBtn) {
      return Promise.resolve(window.confirm(message));
    }

    if (confirmResolver) finishConfirm(false);

    titleEl.textContent = options.title || 'Bestätigen';
    msgEl.textContent = message || '';
    okBtn.textContent = options.confirmLabel || 'OK';
    okBtn.classList.toggle('ptrade-confirm-ok--danger', !!options.danger);

    return new Promise(function (resolve) {
      confirmResolver = resolve;
      openModal('ptrade-confirm-modal');
      okBtn.focus();
    });
  }

  document.getElementById('ptrade-confirm-ok').addEventListener('click', function () {
    closeModal('ptrade-confirm-modal');
    finishConfirm(true);
  });

  document.getElementById('ptrade-confirm-cancel').addEventListener('click', function () {
    closeModal('ptrade-confirm-modal');
    finishConfirm(false);
  });

  document.querySelectorAll('[data-ptrade-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeModalEl(btn.closest('.ptrade-modal'));
    });
  });

  document.querySelectorAll('.ptrade-modal').forEach(function (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModalEl(modal);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ptrade-modal.is-open').forEach(function (modal) {
      closeModalEl(modal);
    });
  });

  function showError(id, message) {
    var el = document.getElementById(id);
    el.textContent = message || '';
    el.hidden = !message;
  }

  var CONTACT_PLACEHOLDERS = {
    whatsapp: '0151… oder +49…',
    instagram: '@deinname',
    discord: 'deinname oder deinname#1234',
    email: 'name@beispiel.de'
  };

  var CONTACT_HINTS = {
    whatsapp: '',
    instagram: 'Dein Instagram-Name — mit oder ohne @.',
    discord: 'Discord-Name oder Link.',
    email: 'Eine E-Mail-Adresse, unter der man dich erreichen kann.'
  };

  function syncContactField(methodSelect, input, hintEl) {
    if (!methodSelect || !input) return;

    var method = methodSelect.value || 'whatsapp';
    input.placeholder = CONTACT_PLACEHOLDERS[method] || CONTACT_PLACEHOLDERS.whatsapp;
    // Keep free text for WhatsApp so spaces/dashes/+49/0151/0049 all work
    input.type = method === 'email' ? 'email' : 'text';
    input.inputMode = method === 'email' ? 'email' : 'text';
    input.autocomplete = method === 'email' ? 'email' : 'off';
    input.removeAttribute('pattern');
    input.removeAttribute('minlength');
    if (hintEl) {
      hintEl.textContent = CONTACT_HINTS[method] || '';
      hintEl.hidden = !CONTACT_HINTS[method];
    }
  }

  function bindContactField(methodSelectId, inputId, hintId) {
    var methodSelect = document.getElementById(methodSelectId);
    var input = document.getElementById(inputId);
    var hintEl = hintId ? document.getElementById(hintId) : null;
    if (!methodSelect || !input) return;

    methodSelect.addEventListener('change', function () {
      syncContactField(methodSelect, input, hintEl);
    });

    syncContactField(methodSelect, input, hintEl);
  }

  bindContactField('ptrade-post-contact-method', 'ptrade-post-contact', 'ptrade-post-contact-hint');
  bindContactField('ptrade-offer-contact-method', 'ptrade-offer-contact', 'ptrade-offer-contact-hint');

  /* Post a prize */

  var postTypeInputs = document.querySelectorAll('input[name="ptrade-post-type"]');
  var postPriceRow = document.getElementById('ptrade-post-price-row');

  postTypeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      postPriceRow.hidden = input.value === 'swap';
    });
  });

  function openPostModal(prizeId) {
    var prize = (state.me.prizes || []).find(function (p) { return p.id === prizeId; });
    if (!prize) return;

    state.postPrize = prize;
    showError('ptrade-post-error', '');

    document.getElementById('ptrade-post-prize').innerHTML =
      '<div class="ptrade-note ptrade-note--flat">'
      + esc((prize.label ? prize.label + ' — ' : '') + prize.title)
      + (prize.lottery_name ? '<br>' + esc(prize.lottery_name) : '')
      + (prize.ships_themselves
        ? '<br>Schon bei dir — Versand und Übergabe klärt ihr untereinander.'
        : '')
      + '</div>';

    syncContactField(
      document.getElementById('ptrade-post-contact-method'),
      document.getElementById('ptrade-post-contact')
    );

    openModal('ptrade-post-modal');
  }

  document.getElementById('ptrade-post-submit').addEventListener('click', function () {
    var button = this;
    var type = document.querySelector('input[name="ptrade-post-type"]:checked').value;

    var body = {
      prize_item_id: state.postPrize.id,
      type: type,
      asking_price: document.getElementById('ptrade-post-price').value,
      wants: document.getElementById('ptrade-post-wants').value,
      contact_method: document.getElementById('ptrade-post-contact-method').value,
      contact_value: document.getElementById('ptrade-post-contact').value,
      customer_name: CUSTOMER_NAME
    };

    button.disabled = true;
    showError('ptrade-post-error', '');

    proxyRequest('/listings', { method: 'POST', body: body })
      .then(function (data) {
        closeModal('ptrade-post-modal');
        toast(data.message || 'Anzeige veröffentlicht.', true);
        document.getElementById('ptrade-post-wants').value = '';
        document.getElementById('ptrade-post-price').value = '';
        return loadMe();
      })
      .then(function () {
        loadBrowse();
        setTab('listings');
      })
      .catch(function (error) { showError('ptrade-post-error', error.message); })
      .finally(function () { button.disabled = false; });
  });

  /* Make an offer */

  var offerTypeInputs = document.querySelectorAll('input[name="ptrade-offer-type"]');
  var offerPrizeRow = document.getElementById('ptrade-offer-prize-row');
  var offerCashRow = document.getElementById('ptrade-offer-cash-row');
  var offerFormView = document.getElementById('ptrade-offer-form-view');
  var offerFormFoot = document.getElementById('ptrade-offer-form-foot');
  var offerBlockedView = document.getElementById('ptrade-offer-blocked-view');
  var offerTitle = document.getElementById('ptrade-offer-title');

  function offerCapabilities(listing) {
    var canSwap = listing.type === 'swap' || listing.type === 'both';
    var canCash = listing.type === 'sell' || listing.type === 'both';
    var hasPrizes = (state.me && state.me.prizes || []).length > 0;
    var canOffer = (canSwap && hasPrizes) || canCash;

    return { canSwap: canSwap, canCash: canCash, hasPrizes: hasPrizes, canOffer: canOffer };
  }

  function offerBlockedMessage(listing, caps) {
    if (caps.canSwap && !caps.hasPrizes && !caps.canCash) {
      return 'Diese Anzeige ist nur zum Tauschen. Du brauchst einen eigenen tauschbaren Preis unter „Meine Preise“, bevor du antworten kannst.';
    }
    return 'Du kannst auf diese Anzeige gerade nicht antworten.';
  }

  function setOfferModalMode(mode, message) {
    var blocked = mode === 'blocked';
    if (offerFormView) offerFormView.hidden = blocked;
    if (offerFormFoot) offerFormFoot.hidden = blocked;
    if (offerBlockedView) offerBlockedView.hidden = !blocked;
    if (offerTitle) offerTitle.textContent = blocked ? 'Angebot nicht möglich' : 'Angebot senden';
    if (blocked) {
      var msg = document.getElementById('ptrade-offer-blocked-message');
      if (msg) msg.textContent = message || '';
    }
  }

  function setOfferType(type) {
    var input = document.querySelector('input[name="ptrade-offer-type"][value="' + type + '"]');
    if (!input) return;
    input.checked = true;
    offerPrizeRow.hidden = type !== 'swap';
    offerCashRow.hidden = type !== 'cash';
  }

  function syncOfferTypeOptions(canSwap, canCash) {
    var prizes = (state.me && state.me.prizes) || [];
    var hasPrizes = prizes.length > 0;

    offerTypeInputs.forEach(function (input) {
      var label = input.closest('label');
      var enabled = input.value === 'swap' ? (canSwap && hasPrizes) : canCash;
      input.disabled = !enabled;
      if (label) {
        label.style.opacity = enabled ? '1' : '0.45';
        label.style.pointerEvents = enabled ? '' : 'none';
      }
    });

    if (hasPrizes && canSwap) {
      setOfferType('swap');
    } else if (canCash) {
      setOfferType('cash');
    } else if (canSwap) {
      setOfferType('swap');
    }

    var addressBlock = document.getElementById('ptrade-offer-address');
    if (addressBlock && state.me) {
      addressBlock.hidden = !needsOfferAddress(state.offerListing);
    }
  }

  function listingNeedsOurShipping(listing) {
    var prize = listing && listing.prize;
    return !(prize && prize.ships_themselves);
  }

  function needsOfferAddress(listing) {
    return !!(state.me && !state.me.has_open_parcel && listingNeedsOurShipping(listing));
  }

  offerTypeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      if (input.disabled) return;
      setOfferType(input.value);
    });
  });

  var offerLoadToken = 0;

  function fillOfferTarget(listing) {
    var prize = listing.prize || {};
    document.getElementById('ptrade-offer-target').innerHTML =
      '<div class="ptrade-note ptrade-note--flat">Du bietest auf: <strong>'
      + esc((prize.label ? prize.label + ' — ' : '') + prize.title) + '</strong>'
      + (listing.asking_price ? '<br>Preisvorstellung: ' + esc(money(listing.asking_price)) : '')
      + (listing.wants ? '<br>Sucht: ' + esc(listing.wants) : '')
      + (prize.ships_themselves
        ? '<br>Dieser Preis ist schon beim Besitzer — Versand klärt ihr untereinander.'
        : '')
      + '</div>';
  }

  function offerChoiceSkeletons(count) {
    var out = '';
    for (var i = 0; i < count; i++) {
      out += '<div class="ptrade-offer-skel" style="display:block;width:100%;height:96px;min-height:96px;border-radius:10px;border:1.5px solid rgba(29,29,29,.14);background:linear-gradient(90deg,#cfd3d9 0%,#e8eaee 45%,#cfd3d9 90%);background-size:200% 100%;animation:ptrade-shimmer 1.2s linear infinite;" aria-hidden="true"></div>';
    }
    return out;
  }

  function showOfferLoadingState() {
    var typeRow = document.getElementById('ptrade-offer-type-row');
    var prizeRow = document.getElementById('ptrade-offer-prize-row');
    var cashRow = document.getElementById('ptrade-offer-cash-row');
    var addressBlock = document.getElementById('ptrade-offer-address');
    var prizeSearch = document.getElementById('ptrade-offer-prize-search');
    var prizeCount = document.getElementById('ptrade-offer-prize-count');
    var choices = document.getElementById('ptrade-offer-choices');
    var submitBtn = document.getElementById('ptrade-offer-submit');

    if (typeRow) typeRow.hidden = true;
    if (cashRow) cashRow.hidden = true;
    if (addressBlock) addressBlock.hidden = true;
    if (prizeRow) prizeRow.hidden = false;
    if (prizeSearch) {
      prizeSearch.hidden = true;
      prizeSearch.value = '';
    }
    if (prizeCount) {
      prizeCount.hidden = false;
      prizeCount.textContent = 'Preise werden geladen…';
    }
    if (choices) {
      choices.classList.add('is-loading');
      choices.style.minHeight = '210px';
      choices.style.background = '';
      choices.style.border = '';
      choices.style.borderRadius = '';
      choices.innerHTML = offerChoiceSkeletons(6);
    }
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Laden…';
    }
    state.offerPrizeIds = [];
  }

  function populateOfferModal(listing) {
    if (!state.me) {
      showError('ptrade-offer-error', 'Konnte deine Preise nicht laden. Bitte erneut versuchen.');
      var choices = document.getElementById('ptrade-offer-choices');
      if (choices) {
        choices.classList.remove('is-loading');
        choices.innerHTML = '<p class="ptrade-hint" style="grid-column:1/-1">Laden fehlgeschlagen.</p>';
      }
      var prizeCount = document.getElementById('ptrade-offer-prize-count');
      if (prizeCount) prizeCount.hidden = false;
      var submitBtn = document.getElementById('ptrade-offer-submit');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Angebot senden';
      }
      return;
    }

    var caps = offerCapabilities(listing);
    if (!caps.canOffer) {
      setOfferModalMode('blocked', offerBlockedMessage(listing, caps));
      return;
    }

    setOfferModalMode('form');
    showError('ptrade-offer-error', '');
    fillOfferTarget(listing);

    document.getElementById('ptrade-offer-type-row').hidden = !(caps.canSwap && caps.canCash);

    var prizeSearch = document.getElementById('ptrade-offer-prize-search');
    if (prizeSearch) {
      prizeSearch.hidden = false;
      prizeSearch.value = '';
    }
    var prizeCount = document.getElementById('ptrade-offer-prize-count');
    if (prizeCount) {
      prizeCount.hidden = false;
      prizeCount.textContent = '0 Preise ausgewählt';
    }

    var choices = document.getElementById('ptrade-offer-choices');
    if (choices) {
      choices.classList.remove('is-loading');
      choices.style.minHeight = '';
      choices.style.background = '';
      choices.style.border = '';
      choices.style.borderRadius = '';
    }

    state.offerPrizeIds = [];
    renderOfferChoices('');
    syncOfferTypeOptions(caps.canSwap, caps.canCash);

    syncContactField(
      document.getElementById('ptrade-offer-contact-method'),
      document.getElementById('ptrade-offer-contact')
    );

    var submitBtn = document.getElementById('ptrade-offer-submit');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Angebot senden';
    }
  }

  function clearOfferChoicesLoading() {
    var choices = document.getElementById('ptrade-offer-choices');
    if (!choices) return;
    choices.classList.remove('is-loading');
    choices.style.minHeight = '';
    choices.style.background = '';
    choices.style.border = '';
    choices.style.borderRadius = '';
  }

  function showSellOnlyOfferForm(listing) {
    setOfferModalMode('form');
    showError('ptrade-offer-error', '');
    fillOfferTarget(listing);

    var typeRow = document.getElementById('ptrade-offer-type-row');
    var prizeRow = document.getElementById('ptrade-offer-prize-row');
    if (typeRow) typeRow.hidden = true;
    if (prizeRow) prizeRow.hidden = true;

    clearOfferChoicesLoading();
    setOfferType('cash');

    syncContactField(
      document.getElementById('ptrade-offer-contact-method'),
      document.getElementById('ptrade-offer-contact')
    );

    var addressBlock = document.getElementById('ptrade-offer-address');
    if (addressBlock) {
      addressBlock.hidden = !(state.me && needsOfferAddress(listing));
    }

    var submitBtn = document.getElementById('ptrade-offer-submit');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Angebot senden';
    }
  }

  function openOfferModal(listingId) {
    if (!CUSTOMER_ID) {
      window.location.href = LOGIN_URL;
      return;
    }

    var listing = state.browse.find(function (l) { return l.id === listingId; });
    if (!listing) return;

    state.offerListing = listing;
    offerLoadToken += 1;
    var token = offerLoadToken;

    setOfferModalMode('form');
    showError('ptrade-offer-error', '');
    fillOfferTarget(listing);
    openModal('ptrade-offer-modal');

    // Sell-only: cash form only — no prize list / skeleton needed
    if (listing.type === 'sell') {
      showSellOnlyOfferForm(listing);
      loadMe({ silent: true }).then(function () {
        if (token !== offerLoadToken) return;
        var modal = document.getElementById('ptrade-offer-modal');
        if (!modal || !modal.classList.contains('is-open')) return;
        if (state.offerListing !== listing) return;
        var addressBlock = document.getElementById('ptrade-offer-address');
        if (addressBlock) {
          addressBlock.hidden = !needsOfferAddress(listing);
        }
        syncContactField(
          document.getElementById('ptrade-offer-contact-method'),
          document.getElementById('ptrade-offer-contact')
        );
      });
      return;
    }

    showOfferLoadingState();

    // Swap / both: refresh prizes so the offer form isn’t empty/stale
    loadMe({ silent: true }).then(function () {
      if (token !== offerLoadToken) return;
      var modal = document.getElementById('ptrade-offer-modal');
      if (!modal || !modal.classList.contains('is-open')) return;
      if (state.offerListing !== listing) return;
      populateOfferModal(listing);
    });
  }

  function renderOfferChoices(filterText) {
    var container = document.getElementById('ptrade-offer-choices');
    var searchInput = document.getElementById('ptrade-offer-prize-search');
    var allPrizes = state.me.prizes || [];
    var q = (filterText != null
      ? filterText
      : (searchInput ? searchInput.value : '')
    ).trim().toLowerCase();

    if (!allPrizes.length) {
      if (searchInput) searchInput.hidden = true;
      var listing = state.offerListing;
      var extra = '';
      if (listing && (listing.type === 'sell' || listing.type === 'both')) {
        extra = ' Wähle oben <strong>Geld bieten</strong> und trage dein Gebot in € ein.';
      } else if (listing && listing.type === 'swap') {
        extra = ' Diese Anzeige ist nur zum Tauschen — du brauchst einen eigenen tauschbaren Preis.';
      }
      container.innerHTML = '<p class="ptrade-hint" style="grid-column:1/-1">'
        + 'Du hast gerade keinen tauschbaren Preis.' + extra + '</p>';
      syncOfferPrizeCount();
      return;
    }

    if (searchInput) {
      searchInput.hidden = false;
    }

    var prizes = !q ? allPrizes : allPrizes.filter(function (prize) {
      var hay = [
        prize.label,
        prize.title,
        prize.lottery_name,
        prize.variant,
        prize.product_id
      ].join(' ').toLowerCase();
      return hay.indexOf(q) !== -1;
    });

    if (!prizes.length) {
      container.innerHTML = '<p class="ptrade-hint" style="grid-column:1/-1">'
        + 'Kein Preis gefunden für „' + esc(q) + '“.</p>';
      syncOfferPrizeCount();
      return;
    }

    container.innerHTML = prizes.map(function (prize) {
      var selected = state.offerPrizeIds.indexOf(Number(prize.id)) !== -1;
      return '<label class="ptrade-choice' + (selected ? ' is-selected' : '') + '">'
        + '<input type="checkbox" name="ptrade-offer-prize" value="' + prize.id + '"' + (selected ? ' checked' : '') + '>'
        + (prize.image
          ? '<img src="' + esc(prize.image) + '" alt="' + esc(prize.title) + '" loading="lazy">'
          : '<div style="aspect-ratio:1/1;display:grid;place-items:center;color:#d6c6ad">?</div>')
        + '<span class="ptrade-choice-check" aria-hidden="true">✓</span>'
        + '<span class="ptrade-choice-label">' + esc(prize.label || '') + '<br>' + esc(prize.title || '') + '</span>'
        + '</label>';
    }).join('');

    container.querySelectorAll('.ptrade-choice').forEach(function (choice) {
      var input = choice.querySelector('input');
      input.addEventListener('change', function () {
        var id = Number(input.value);
        if (input.checked && state.offerPrizeIds.indexOf(id) === -1) {
          state.offerPrizeIds.push(id);
        } else if (!input.checked) {
          state.offerPrizeIds = state.offerPrizeIds.filter(function (selectedId) {
            return selectedId !== id;
          });
        }
        choice.classList.toggle('is-selected', input.checked);
        syncOfferPrizeCount();
      });
    });

    syncOfferPrizeCount();
  }

  function syncOfferPrizeCount() {
    var count = document.getElementById('ptrade-offer-prize-count');
    if (!count) return;
    var total = state.offerPrizeIds.length;
    count.textContent = total + (total === 1 ? ' Preis ausgewählt' : ' Preise ausgewählt');
  }

  var offerPrizeSearch = document.getElementById('ptrade-offer-prize-search');
  if (offerPrizeSearch) {
    offerPrizeSearch.addEventListener('input', function () {
      renderOfferChoices(offerPrizeSearch.value);
    });
  }

  function collectAddress() {
    return {
      first_name: document.getElementById('ptrade-addr-first').value,
      last_name: document.getElementById('ptrade-addr-last').value,
      address1: document.getElementById('ptrade-addr-street').value,
      zip: document.getElementById('ptrade-addr-zip').value,
      city: document.getElementById('ptrade-addr-city').value,
      country: 'DE'
    };
  }

  document.getElementById('ptrade-offer-submit').addEventListener('click', function () {
    var button = this;
    var offerType = document.querySelector('input[name="ptrade-offer-type"]:checked').value;

    if (offerType === 'swap' && !state.offerPrizeIds.length) {
      showError('ptrade-offer-error', 'Wähle mindestens einen Preis aus, den du abgeben möchtest.');
      return;
    }

    if (offerType === 'cash') {
      var cashAmount = parseFloat(document.getElementById('ptrade-offer-cash').value);
      if (!cashAmount || cashAmount <= 0) {
        showError('ptrade-offer-error', 'Gib dein Gebot in € ein.');
        return;
      }
    }

    var body = {
      listing_id: state.offerListing.id,
      offer_type: offerType,
      offered_prize_item_ids: offerType === 'swap' ? state.offerPrizeIds.slice() : [],
      cash_amount: document.getElementById('ptrade-offer-cash').value,
      message: document.getElementById('ptrade-offer-message').value,
      contact_method: document.getElementById('ptrade-offer-contact-method').value,
      contact_value: document.getElementById('ptrade-offer-contact').value,
      offerer_name: CUSTOMER_NAME
    };

    if (needsOfferAddress(state.offerListing)) {
      body.address = collectAddress();
    }

    button.disabled = true;
    showError('ptrade-offer-error', '');

    proxyRequest('/offers', { method: 'POST', body: body })
      .then(function (data) {
        closeModal('ptrade-offer-modal');
        toast(data.message || 'Angebot gesendet.', true);
        document.getElementById('ptrade-offer-message').value = '';
        return loadMe();
      })
      .then(function () { setTab('offers'); })
      .catch(function (error) { showError('ptrade-offer-error', error.message); })
      .finally(function () { button.disabled = false; });
  });

  /* Mark a deal agreed elsewhere */

  function openCompleteModal(listingId) {
    var listing = (state.me.listings || []).find(function (l) { return l.id === listingId; });
    if (!listing) return;

    state.completeListing = listing;
    showError('ptrade-complete-error', '');

    var pending = (listing.offers || []).filter(function (o) { return o.status === 'pending'; });
    var pickerRow = document.getElementById('ptrade-complete-offer-row');
    var offerSelect = document.getElementById('ptrade-complete-offer');
    var emailLabel = document.getElementById('ptrade-complete-email-label');

    pickerRow.hidden = pending.length === 0;
    offerSelect.innerHTML = '<option value="">— auswählen —</option>' + pending.map(function (offer) {
      return '<option value="' + offer.id + '">' + esc(offer.offerer_name) + '</option>';
    }).join('');

    if (emailLabel) {
      emailLabel.textContent = pending.length
        ? 'Oder Shop-E-Mail des Empfängers'
        : 'Shop-E-Mail des Empfängers';
    }

    document.getElementById('ptrade-complete-email').value = '';
    openModal('ptrade-complete-modal');
  }

  document.getElementById('ptrade-complete-submit').addEventListener('click', function () {
    var button = this;
    var offerId = document.getElementById('ptrade-complete-offer').value;
    var email = document.getElementById('ptrade-complete-email').value.trim();

    if (!offerId && !email) {
      showError('ptrade-complete-error', 'Wähle eine Person aus oder gib ihre E-Mail ein.');
      return;
    }

    var body = {
      completed_type: document.querySelector('input[name="ptrade-complete-type"]:checked').value,
      offer_id: offerId || null,
      to_email: email || null
    };

    button.disabled = true;
    showError('ptrade-complete-error', '');

    proxyRequest('/listings/' + state.completeListing.id + '/complete', { method: 'POST', body: body })
      .then(function (data) {
        closeModal('ptrade-complete-modal');
        toast(data.message || 'Eingetragen.', true);
        document.getElementById('ptrade-complete-email').value = '';
        return loadMe();
      })
      .then(function () { loadBrowse(); })
      .catch(function (error) { showError('ptrade-complete-error', error.message); })
      .finally(function () { button.disabled = false; });
  });

  /* ---------- boot ---------- */

  function loadFilters() {
    fetch(API + '/api/trade/filters')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        (data.lotteries || []).forEach(function (lottery) {
          var option = document.createElement('option');
          option.value = lottery.product_id;
          option.textContent = lottery.name;
          lotterySelect.appendChild(option);
        });
      })
      .catch(function () { /* filters are a nicety, the feed still works */ });
  }

  // Deep link: ?tab=listings (also still accepts legacy #mine)
  var initialTab = tabFromUrl();
  if (initialTab) {
    setTab(initialTab);
  }

  loadBrowse();
  loadFilters();

  // Always ask the App Proxy — Liquid customer can be empty with Shopify's
  // new customer accounts even when the account page still shows you logged in.
  mineGrid.innerHTML = skeletons(4);
  listingsGrid.innerHTML = skeletons(3);
  if (inboxGrid) inboxGrid.innerHTML = skeletons(2);
  offersGrid.innerHTML = skeletons(2);
  loadMe();
})();
